import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Tooltip from 'kpc/components/tooltip';
import { Table, TableColumn } from 'kpc/components/table';
import Tip from 'kpc/components/tip';
import Icon from 'kpc/components/icon';
import Button from 'kpc/components/button';
import Input from 'kpc/components/input';
import KsSelect from '../KsSelect/index.vue';
import pForm, { FormItem } from 'kpc/components/form';
import { Select, Option } from 'kpc/components/select';
import Spinner from 'kpc/components/spinner';
import * as _ from 'lodash'
import vpcData from "../../service/vpc/vpcData";
import whiteList from "../../service/common/whiteList";
import { v4 as uuidv4 } from 'uuid';
import * as ipAddr from 'ip-address'

export class RuleItem {
    Direction = 'in';
    uniqId: string = '';
    RuleNumber: number = 100;
    Protocol: string = 'tcp';
    Policy: string = 'Accept';
    Priority: number = 1;
    RuleAction: string = 'allow';
    PortRangeFrom?: number;
    PortRangeTo?: number;
    IcmpType?: string | number = '-1';
    IcmpCode?: string | number = 0;
    CidrBlock: string = '';
    CidrBlocks: any[] = [];
    ProtocolPort: any[] = [];
    RuleTag: string = '';
    SecurityGroupEntryId: string = '';
    editTagDisabled: boolean = false;
    isError: boolean = false;
    errorMsg: string = '';
    Description: string = '';
    LoadBalancerAclEntryId: string = '';

    constructor(direction: string) {
        this.uniqId = uuidv4().toString();
        this.Direction = direction;
    }

    getParams() {
        let ruleItemParams: any = {
            Protocol: this.Protocol,
            Policy: this.Policy,
            Priority: this.Priority,
            CidrBlock: this.CidrBlock,
            Direction: this.Direction,
            PortRangeFrom: this.PortRangeFrom,
            RuleTag: this.RuleTag,
            Description: this.Description,
            SecurityGroupEntryId: this.SecurityGroupEntryId
        }

        switch (this.Protocol) {
            case 'ssh':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 22;
                ruleItemParams.PortRangeTo = 22;
                break;
            case 'http':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 80;
                ruleItemParams.PortRangeTo = 80;
                break;
            case 'https':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 443;
                ruleItemParams.PortRangeTo = 443;
                break;
            case 'remote':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 3389;
                ruleItemParams.PortRangeTo = 3389;
                break;
            case 'openvpn':
                ruleItemParams.Protocol = 'udp';
                ruleItemParams.PortRangeFrom = 1194;
                ruleItemParams.PortRangeTo = 1194;
                break;
            case 'ping':
                ruleItemParams.Protocol = 'icmp';
                ruleItemParams.IcmpCode = 0;
                ruleItemParams.IcmpType = 8;
                break;
            case 'tcp':
            case 'udp':
                ruleItemParams.Protocol = this.Protocol
                ruleItemParams.PortRangeFrom = Number(this.PortRangeFrom)
                ruleItemParams.PortRangeTo = Number(this.PortRangeTo)
                break;
            case 'icmp':
                ruleItemParams.Protocol = 'icmp';
                ruleItemParams.IcmpCode = Number(this.IcmpType == -1 ? '-1' : this.IcmpCode);
                ruleItemParams.IcmpType = Number(this.IcmpType);
            default:
                break;
        }
        return ruleItemParams;
    }
}

@Component({
    components: {
        Tooltip,
        Tip,
        Table, TableColumn,
        Icon,
        Spinner,
        Button,
        Input,
        pForm, FormItem,
        Select, Option,
        KsSelect
    }
})
export default class GroupRuleTable extends Vue {
    @Prop({
        default: 'in'
    })
    direct!: string

    @Prop({
        default: 'ipv6'
    })
    ipVersion!: String

    @Prop({
        default: 'cn-qingyangtest-1'
    })
    region!: String

    @Prop({
        default: 'create'
    })
    originPage!: String

    @Prop({
        default: false
    })
    sgSupportEpcDeny!: false

    @Prop({
        default: 0
    })
    interfaceEpcCount!: Number

    @Prop({
        default: false
    })
    globalGroup !: boolean

    rules: RuleItem[] = [];
    rulesClone: RuleItem[] = [];
    deletedRuleId: any[] = [];

    expandedKeys: any[] = [];

    policyList: any[] = [
        { title: this.$trans(`允许`), value: 'Accept' },
        { title: this.$trans(`拒绝`), value: 'Drop' }
    ]
    protocolList: any[] = [
        { title: 'IP', value: 'ip' },
        { title: 'ICMP', value: 'icmp' },
        { title: 'TCP', value: 'tcp' },
        { title: 'UDP', value: 'udp' },
        { title: 'ICMP ping', value: 'ping' },
        { title: 'TCP ssh(22)', value: 'ssh' },
        { title: 'TCP http(80)', value: 'http' },
        { title: 'TCP https(443)', value: 'https' },
        { title: 'UDP openvpn(1194)', value: 'openvpn' },
        { title: this.$trans(`TCP Windows远程登录`), value: 'remote' }
    ];
    IcmpTypeList: any[] = [
        { title: this.$trans(`全部协议`), value: '-1' },
        { title: 'Echo Reply', value: '0' },
        { title: 'Destination Unreachable', value: '3' },
        { title: 'Source Quench', value: '4' },
        { title: 'Redirect Message', value: '5' },
        { title: 'Echo', value: '8' },
        { title: 'Router Advertisement', value: '9' },
        { title: 'Router Solicitation', value: '10' },
        { title: 'Time Exceeded', value: '11' },
        { title: 'Parameter Problem: Bad IP header', value: '12' },
        { title: 'Timestamp', value: '13' },
        { title: 'Timestamp Reply', value: '14' },
        { title: 'Information Request', value: '15' },
        { title: 'Information Reply', value: '16' },
        { title: 'Address Mask Reques', value: '17' },
        { title: 'Address Mask Reply', value: '18' },
        { title: 'Traceroute', value: '30' },
    ];
    IcmpTypePortList: any[] = [];
    protocolPortList: any[] = [
        { title: "SSH（22）", value: "22" },
        { title: "Telnet（23）", value: "23" },
        { title: "HTTP（80）", value: "80" },
        { title: "HTTPS（443）", value: "443" },
        { title: "MS SQL（1433）", value: "1433" },
        { title: "Oracle（1521）", value: "1521" },
        { title: "MySQL（3306）", value: "3306" },
        { title: "RDP（3389）", value: "3389" },
        { title: "PostgreSQL（5432）", value: "5432" },
        { title: "Redis（6379）", value: "6379" },
        { title: "ALL（1-65535）", value: "1-65535" }
    ];
    // cidrBlockList: any[] = [
    //     { title: "0.0.0.0/0", value: "0" },
    //     { title: "10.0.0.0/8", value: "8" },
    //     { title: "172.16.0.0/12", value: "12" },
    //     { title: "192.168.0.0/16", value: "16" },
    //     { title: "::/0", value: "999" }
    // ];
    icmpTypes = vpcData.icmpTypes

    get cidrBlockList() {
        const blockList = [
            { title: "0.0.0.0/0", value: "0" },
            { title: "10.0.0.0/8", value: "8" },
            { title: "172.16.0.0/12", value: "12" },
            { title: "192.168.0.0/16", value: "16" },
        ];
        if (!this.globalGroup) {
            blockList.push({ title: "::/0", value: "999" })
        }

        return blockList;        
    }

    get ipDirectTitle() {
        switch (this.direct) {
            case 'in':
                return this.$trans(`源IP`);
            case 'out':
                return this.$trans(`目标IP`);
            default:
                return 'IP';
        }
    }

    get regionSupportDeny() {
        let me: any = this;
        // let region = this.$route.params.region;
        let region = me.region || me.$route.params.region;
        return whiteList.check("sgSupportDeny", region);
    }

    @Watch("rules", {
        deep: true
    })
    rulesWatcher(val: any, oldVal: any) {
        let me: any = this;
        //如果找不到icmpCode 那么设置0 永远是选中第一个icmpCode
        _.forEach(val, (item) => {
            if (item.IcmpType == '' || item.IcmpType == null) { return; }
            let code = me.getIcmpCode(item.IcmpCode, item.IcmpType)
            if (!code) {
                item.IcmpCode = 0;
            }
        });
    }

    @Watch("interfaceEpcCount")
    interfaceEpcCountWatcher(val: any) {
        let me: any = this;
        me.setRules(me.rules);
    }

    @Watch("sgSupportEpcDeny")
    sgSupportEpcDenyWatcher(val: any) {
        let me: any = this;
        me.setRules(me.rules);
    }
    
    created() {
        let me: any = this;
        me.getIcmpTypePortList();
    }

    getIcmpTypePortList() {
        let me: any = this;
        // 生成icmp协议对应的协议端口列表
        let icmpTypePort: any[] = [];
        _.forEach(me.IcmpTypeList, item => {
            _.forEach(me.icmpTypes[item.value], subitem => {
                if (item.value == "-1") {
                    icmpTypePort.push({
                        title: item.title,
                        value: "-1"
                    });
                } else {
                    icmpTypePort.push({
                        title: item.title + " - " + subitem.text,
                        value: item.value + "-" + subitem.value
                    });
                }
            });
        });
        me.IcmpTypePortList = icmpTypePort;
    }

    getIcmpCode(code: any, type: any) {
        let me: any = this;
        if (code == '-1') {
            code = 0;
        }
        let text;
        _.forEach(me.icmpTypes[type], (item) => {
            if (item.value == code) {
                text = item.text
            }
        })
        return text;
    }

    setRules(srcRules: any[]) {
        let me: any = this;
        let expandedKeys: any[] = [];
        let rules: RuleItem[] = [];
        _.forEach(srcRules, (item, index) => {
            let r = new RuleItem(me.direct);
            let _policy = item.Policy || 'Accept';
            let _ProtocolPort: any[] = [];

            if (item.Protocol == "icmp") {
                if (item.IcmpType === "-1" || _.toString(item.IcmpType).split("-").length > 1) {
                    item.IcmpType = _.toString(item.IcmpType);
                } else {
                    item.IcmpType = _.toString(item.IcmpType) + "-" + _.toString(item.IcmpCode);
                }
            } else if (item.Protocol == "tcp" || item.Protocol == "udp") {
                if (item.ProtocolPort && item.ProtocolPort.length) {
                    _ProtocolPort = item.ProtocolPort;
                } else {
                    if (item.PortRangeFrom === item.PortRangeTo) {
                        if (!item.PortRangeFrom && item.ProtocolPort) {
                            _ProtocolPort = item.ProtocolPort;
                        } else {
                            _ProtocolPort = [_.toString(item.PortRangeFrom)];
                        }
                    } else {
                        _ProtocolPort = [item.PortRangeFrom + "-" + item.PortRangeTo];
                    }
                }
            }

            if (me.interfaceEpcCount && !me.sgSupportEpcDeny && item.Policy == "Drop") {
                _policy = 'Accept';
            }
            r.Protocol = item.Protocol
            r.Policy = _policy
            r.Priority = item.Priority || 1
            r.CidrBlock = item.CidrBlock
            r.CidrBlocks = item.CidrBlock ? _.toString(item.CidrBlock).split(",") : []
            r.ProtocolPort = _ProtocolPort
            r.IcmpType = item.IcmpType == null ? '-1' : _.toString(item.IcmpType)
            r.IcmpCode = item.IcmpCode
            r.PortRangeFrom = item.PortRangeFrom
            r.PortRangeTo = item.PortRangeTo
            r.RuleTag = item.RuleTag
            r.Description = item.Description
            r.SecurityGroupEntryId = item.SecurityGroupEntryId
            r.editTagDisabled = item.editTagDisabled ? true : false
            r.isError = item.isError
            r.errorMsg = item.errorMsg

            if (item.isError) {
                expandedKeys.push(index);
            }
            rules.push(r);
        });
        
        // 按优先级排序：从上至下，数字越小越靠前
        // 优先级相同，访问权限不同：拒绝 > 允许
        // rules = _.orderBy(rules, ["Priority", "Policy"], ["asc", "desc"]);
        rules.sort((a: any, b: any) => {
            if (a.Priority > b.Priority) {
                return 1;
            } else if (a.Priority === b.Priority) {
                if (a.Policy != b.Policy) {
                    if (a.Policy == "Accept") {
                        return 1;
                    } else {
                        return -1;
                    }
                } else {

                    let ProtocolA = 0;
                    let ProtocolB = 0;
                    for (let i = 0; i < 4; ++i) {
                        if (a.Protocol.includes(me.protocolList[i].value)) {
                            ProtocolA = i;
                        }
                        if (b.Protocol.includes(me.protocolList[i].value)) {
                            ProtocolB = i;
                        }
                    }
                    if (ProtocolA > ProtocolB) {
                        return 1;
                    } else if (ProtocolA == ProtocolB) {
                        if (a.Protocol.includes('tcp') || a.Protocol.includes('udp') ) {
                            if (a.PortRangeFrom > b.PortRangeFrom) {
                                return 1;
                            } else if (a.PortRangeFrom < b.PortRangeFrom) {
                                return -1;
                            }
                        }
                        if (a.Protocol.includes('icmp')) {
                            let indexA = 0;
                            let indexB = 0;
                            for(let i=0; i< me.IcmpTypePortList.length; ++i) {
                                if (me.IcmpTypePortList[i].value == a.IcmpType) {
                                    indexA = i;
                                }
                                if (me.IcmpTypePortList[i].value == b.IcmpType) {
                                    indexB = i;
                                }
                            }

                            if (indexA > indexB) {
                                return 1;
                            } else if (indexA < indexB) {
                                return -1;
                            }
                        }

                        const timeA = new Date(me.getCreateTime(a.CreateTime)).getTime();
                        const timeB = new Date(me.getCreateTime(b.CreateTime)).getTime();
                        return timeA > timeB ? -1 : 1;
                    } else {
                        return -1;
                    }
                    //(timeA > timeB ? 1 : -1);
                }
            } else {
                return -1;
            }
        })
        me.expandedKeys = expandedKeys;
        me.rules = rules;
        me.rulesClone = _.cloneDeep(rules);
    }

    // 新加
    getCreateTime(time:string) {
        const me = this;

        if (time && time.includes(',')) {
            const temp = time.split(',')
            const numberTime = temp.map((ele: string) => {
                return new Date(ele).getTime();
            });
            let tempInd = 0;
            let maxTime = 0;
            numberTime.forEach((ele: number, ind: number) => {
                if (ele > maxTime) {
                    maxTime = ele;
                    tempInd = ind
                }
            })
            return temp[tempInd];
        }
        return time;

    }

    updateProtocols(protocols: any[]) {
        this.protocolList = protocols;
    }

    addRuleItem(prop: any, protocol: any, ipVersion: string) {
        let me: any = this;
        let item = new RuleItem(me.direct);
        if (ipVersion === 'ipv4') {
            item.CidrBlock = '0.0.0.0/0'
            item.CidrBlocks = ["0.0.0.0/0"];
        }
        if (ipVersion === 'ipv6') {
            item.CidrBlock = '::/0'
            item.CidrBlocks = ["::/0"];
        }
        if (me.rules.length > 0) {
            let lastRuleNumber = _.last(this.rules)!.RuleNumber;
            item.RuleNumber = lastRuleNumber + 10;
        }
        if (prop == 'init') {
            item.Protocol = protocol;
        }
        me.rules.push(item);
    }

    getIcmpTypes() {
        return vpcData.getIcmpTypes();
    }

    checkRuleNumber(ruleNumber?: number) {
        if (!ruleNumber) {
            return false;
        }
        return ruleNumber < 1000 && ruleNumber > 0
    }

    checkCidrBlock(cidrBlock?: string) {
        let me: any = this;
        cidrBlock = _.trim(cidrBlock);
        if (!cidrBlock) {
            return false;
        }
        if (cidrBlock.indexOf('/') === -1) {
            return false;
        }

        if (me.ipVersion === 'ipv4') {
            return new ipAddr.Address4(cidrBlock).isValid()
        }
        if (me.ipVersion === 'ipv6' && !me.golbalGroup) {
            var cirIp = cidrBlock.split('/')[0];
            var cirNum = cidrBlock.split('/')[1];
            if (Number(cirNum) > 32 || Number(cirNum) < 0 || (cirIp == "0.0.0.0" && Number(cirNum) != 0)) {
                return new ipAddr.Address6(cidrBlock).isValid();
            } else {
                return true;
            }
        }
    }

    //删除入站规则
    deleteRuleInPage(index: any) {
        let me: any = this;
        if (me.rules[index].SecurityGroupEntryId) {
            me.deletedRuleId.push(me.rules[index].SecurityGroupEntryId)
        }

        me.rules.splice(index, 1);
        
        // if (!me.rules[index + 1]) {
        //     me.rules.splice(index, 1)
        //     return;
        // }

        // if (me.rules[index + 1].isError) {
        //     me.rules.splice(index, 2)
        // } else {
        //     me.rules.splice(index, 1)
        // }
    }

    //复制出入站规则
    copyRuleInPage(index: any) {
        let me: any = this;
        let rulesItem = _.cloneDeep(me.rules[index]);
        rulesItem.uniqId = uuidv4().toString();
        me.rules.push(rulesItem);
    }

    getRules() {
        let me: any = this;
        let rules = me.rules;
        let rulesMap: any = {};
        for (let i = 0; i < rules.length; i++) {
            let ruleItem = rules[i];
            let checkCidrBlockOk = me.checkCidrBlock(ruleItem.CidrBlock);
            if (!checkCidrBlockOk) {
                return;
            }
            let ruleItemParams = ruleItem.getParams();
            let uniqKey = JSON.stringify(ruleItemParams);
            rulesMap[uniqKey] = ruleItemParams;
        }

        return _.values(rulesMap);
    }
}
